import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class SetAuthorizedTokenUsecase {
  constructor(private readonly repo: AppAccountSettingRepository) {}

  execute(token: string) {
    return this.repo.setAuthorizedToken(token);
  }
}
